import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { Close, MarginBottom, SaveChanges } from '../../../../Constant';
import Loader from '../../../../Common/Component/Loader';
import TakeActionTab from '../../../Pages/UsersMangement/TakeActionTab';

const CommonModal = (props) => {
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggler} size={props.size} centered>
      <ModalHeader toggle={props.toggler} className='show-color'>
        {props.title}
      </ModalHeader>
      <ModalBody className={props.bodyClass}>
        {props.children}
      </ModalBody>
      <ModalFooter>
        {props.data && props.students && <TakeActionTab data={props.data} setData={props.setData} students={props.students} setStudents={props.setStudents} />}
        {!props.showCloseBtn && <Btn attrBtn={{ color: 'secondary', onClick: props.toggler }} style={{MarginBottom:"-5px"}} >{Close}</Btn>
        }        <Btn attrBtn={{ color: 'primary', onClick: props.success, disabled: props.disabled }}>{props.loading ? <Loader /> : props.successText}</Btn>
      </ModalFooter>
    </Modal>
  );
};

export default CommonModal;